export default __webpack_public_path__ + "static/media/hearth-TN.55509d3c.png";